var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-row"},[_c('div',{staticClass:"c-tr p-3"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.data}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }